export default __webpack_public_path__ + "static/media/swiper3.e131ca13.png";